"use client";
'use strict';

var React = require('react');

const ConfigContext = React.createContext({
    apiGateWayURL: 'https://api.sravni.ru',
    gatewayUrl: 'http://gateway.svc.master.qa.sravni-team.ru',
    publicUrl: 'http://public.master.qa.sravni-team.ru',
});
// @deprecated
const ConfigProvider = ConfigContext.Provider;

exports.ConfigContext = ConfigContext;
exports.ConfigProvider = ConfigProvider;
//# sourceMappingURL=ConfigProvider.js.map
